import React from 'react';
import ListUtils from '../../helpers/common/ListUtils';

/**
 * @param {TryAgainArgs} param0 
 */
const TryAgain = ({show, className, onTryAgainClicked, hasCancel, onCloseClicked, children}) => {

    if (show === undefined)
        show = true;

    if (hasCancel === undefined)
        hasCancel = true;

    return (
        <div 
            className={ListUtils.toHtmlClasses([
                className || "",
                "tryagain",
                !show ? "react-embedded-hide" : "",
            ])}
        >
            {children}
            <div className="tryagain-buttons">
                <button type="button"
                    className="tryagain-confirm"
                    onClick={onTryAgainClicked}
                    // TODO: localization
                >
                    Try again
                </button>

                {hasCancel &&
                    <button type="button"
                        className="tryagain-cancel"
                        onClick={onCloseClicked}
                        // TODO: localization
                    >
                        Cancel
                    </button>
                }
            </div>
        </div>
    );
};

export default TryAgain;
